/**
 * @notes: Endpoints for client accounts
 */

export const CLIENT_ENDPOINT = "/clients";
export const ADDITIONAL_INFOS_ENDPOINT = "/additional_infos";
